export default __webpack_public_path__ + "static/media/dk.f4e8fc53.svg";